/**
 * The message the chat is waiting on, remembered across a navigation or a reload.
 *
 * A chat answer is generated by a worker and polled for, so leaving the page does not
 * cancel it: the id is kept here and the poll is picked up again on the way back. Which
 * means the opposite also has to be deliberate — a session that is being thrown away has
 * to forget it, or the next page load waits for an answer belonging to a conversation
 * that no longer exists. That is a loading indicator with nothing behind it and no way
 * for the person to clear it.
 *
 * One key, named in one place, because the two halves live in different components:
 * ChatArea does the waiting and Main and the sidebar do the discarding.
 */

export const PENDING_MSG_KEY = 'chat_pending_message_id';

/** Stop waiting for whatever answer was in flight. */
export function forgetPendingMessage(): void {
  try {
    localStorage.removeItem(PENDING_MSG_KEY);
  } catch {
    // A browser with storage blocked was never waiting on anything.
  }
}
